import React from 'react';
import '../css/Footer.css'

export default function Footer() {
    return (
        <div className="footer">
             <p>2020 	&#169;Claudia Cristina Vamesu</p> 
        </div>
    )
}
